<template>
  <div>
    <FormForgetPassword
        v-if="state == 'form-contactnumber'"
        :modalController="modalController"
        @onclick="submitContactNumber($event)">
    </FormForgetPassword>
    <FormOtp
        v-if="state == 'form-otp'"
        :modalController="modalController"
        :otpData="otpData"
        @submitOtp="changePasswordState($event)"
        >
    </FormOtp>
    <FormChangePassword v-if="state == 'form-changepassword'"
        @onclick="apiChangePassword($event)"
        :modalController="modalController"
    >
    </FormChangePassword>
    <ModalMaster :controller="modalController"></ModalMaster>
  </div>
</template>

<script>
import FormForgetPassword from '../component/FormForgetPassword.vue';
import FormOtp from '../component/FormOtp.vue';
import FormChangePassword from '../component/FormChangePassword.vue'
import ForgetPasswordOtpService from '../Service/ForgetPasswordOtpService'
//mixins
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    mixins: [ModalMixin,LocaleMixin],
    components:{
        FormForgetPassword,
        FormOtp,
        FormChangePassword
    },
    data: function(){
        return {
            state: 'form-contactnumber', //form-contactnumber , form-otp ,  form-changepassword
            otpData: {
                tel: '',
                refcode: '',
                otp: ''
            },
        }
    },
    methods:{
        submitContactNumber: async function(data){
            this.otpData.tel = data.mobile;
            this.modalController.loadingModal.show();
            let success = await this.apiRequestOtp();
            this.modalController.loadingModal.hide();
            if(success){
                this.state = 'form-otp'
            }
        },
        apiRequestOtp: function () {
            return new Promise((resolve) => {
                ForgetPasswordOtpService.requestOtp(this.otpData.tel)
                .subscribe({
                    next: (res) => {
                        this.otpData.refcode = res.data.RefCode
                        resolve(true);
                    },
                    error: (err) => {
                        console.log(err)
                        this.handleError(err);
                        resolve(false);
                    }
                });
            })
        },
        changePasswordState: function(data){
            this.otpData.otp = data.otp
            this.state = 'form-changepassword'
        },
        apiChangePassword: function(data){
            let params = {
                contactNumber: this.otpData.tel,
                refcode: this.otpData.refcode,
                otp: this.otpData.otp,
                password_type: data.password_type,
                password: data.password_type == 'pin' ? data.pin : data.password,
                confirmpassword: data.password_type == 'pin' ? data.confirmpin : data.confirmpassword
            }
            console.log(params)
            this.modalController.loadingModal.show();
            return new Promise((resolve) => {
                ForgetPasswordOtpService.changePassword(params)
                .subscribe({
                    next: (res) => {
                        this.modalController.successModal
                            .setTitle(this.lbl.forgetpassword.success)
                            .setBtnOk(this.lbl.home.login.login)
                            .show();
                        this.modalController.successModal.onClickOk(() => {
                            this.$router.push('/');
                        });
                        this.modalController.loadingModal.hide();
                        resolve(res);
                    },
                    error: (err) => {
                        console.log(err)
                        this.handleError(err);
                        this.modalController.loadingModal.hide();
                        resolve(false);
                    }
                });
            })
        },
        handleError: function (err) {
            this.modalController.alertModal.setTitle(this.lbl.profile.error).setMsg(err.message).show();
        },
    }
}
</script>

<style>

</style>
